import React from "react";
import { Card, CardContent, Box, Stack, Typography } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import type { AppProduct } from "@shared/interfaces/product";
import { useText } from "../../main.tsx";

interface Props {
    product: AppProduct,
    index: number,
    handleProductClick: (type: string) => void,
}

const getTranslationKeyByType = (type: string): string => {
    switch (type) {
        case "Solar Panel":
            return "funnel.wizard.productList.module";
        case "Wechselrichter":
            return "funnel.wizard.productList.inverter";
        case "Battery":
            return "funnel.wizard.productList.battery";
        case "Accessory":
            return "funnel.wizard.productList.accessory";
        case "Service Package":
            return "funnel.wizard.productList.servicePackage";
        default:
            return "funnel.wizard.productList.unknown";
    }
}

const ProductItem: React.FC<Props> = ({ product, index, handleProductClick }) => {
    const { t } = useText();
    return (
        <Card
            key={`${product.type}-${index}`}
            sx={{
                borderRadius: 2.5,
                boxShadow: "0px 10px 7.5px rgba(0,0,0,0.02)",
                backdropFilter: "blur(25px)",
            }}
        >
            <CardContent sx={{  px: 3, 
                                "&:last-child": { pb: 3 },
                                cursor: 'pointer' }}
                         onClick={() => handleProductClick(product.type)}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h5" sx={{ mb: 0.25 }}>
                            {t(`${getTranslationKeyByType(product.type)}.title`)}
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.75, }}>
                            {product.name}
                        </Typography>
                    </Box>
                    <ExpandMore
                        sx={{ fontSize: 20 }}
                        onClick={() => handleProductClick(product.type)}
                    />
                </Stack>
            </CardContent>
        </Card>
    );
};

export default ProductItem;